import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { Log } from 'ng2-logger';
import { InsertionCycle } from '@app/shared/models/insertion-cycle.model';
import { Line } from '@app/shared/models/line.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PermissionService } from '@app/authentication/services/permission.service';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { LineService } from '@app/core/services/line.service';
import { PickList } from "primeng/picklist";

@Component({
    selector: 'app-insertion-cycles-create-modal',
    templateUrl: './insertion-cycles-create-modal.component.html',
    styleUrls: ['./insertion-cycles-create-modal.component.scss']
})
export class InsertionCyclesCreateModalComponent implements OnInit {
    private _logger = Log.create(InsertionCyclesCreateModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(PickList, {static: true}) pickList: PickList;

    @Input() insertionCycle: InsertionCycle;
    @Input() isLoading = true;
    @Input() isReadOnly = false;
    @Output('onCreate') onCreate: EventEmitter<any> = new EventEmitter();
    @Output('onUpdate') onUpdate: EventEmitter<any> = new EventEmitter();
    @Output('onDelete') onDelete: EventEmitter<any> = new EventEmitter();

    public lines: Line[] = [];
    public form: UntypedFormGroup;
    public selectedLines: Line[] = [];
    public showValidations = false;
    public validationErrors: any;
    public inUse = true;
    public isEditMode = false;

    private previousLines: Line[] = [];

    constructor(private permissionService: PermissionService,
                private linesService: LineService) {
    }

    public ngOnInit() {
        this.form = new UntypedFormGroup({
            name: new UntypedFormControl('', [Validators.required]),
        });
        this.getLines();
    }

    public open(insertionCycle = new InsertionCycle) {
        this.reset();
        this.isEditMode = !!insertionCycle.id;
        this.previousLines = [...insertionCycle.assignedLines];
        this.loadFormValue(insertionCycle);
        this.modal.open();
    }

    public createInsertionCycle() {
        if (!this.isFormValid()) {
            return;
        }
        this.onCreate.emit(this.getFormValue());
    }

    public updateInsertionCycle() {
        if (!this.isFormValid()) {
            return;
        }
        this.onUpdate.emit(this.getFormValue());
    }

    public deleteInsertionCycle() {
        this.onDelete.emit(this.getFormValue());
    }

    public closeModal() {
        this.selectedLines = this.previousLines;
        this.insertionCycle.assignedLines = this.selectedLines;
        this.modal.close();
    }

    public onLinesChange() {
        this.insertionCycle.assignedLines = this.selectedLines;
    }

    private reset() {
        this.showValidations = false;
        this.validationErrors = {};
        this.form.reset();
    }

    private loadFormValue(insertionCycle) {
        this.insertionCycle = insertionCycle;
        this.form.setValue({name: insertionCycle.name});
    }

    private getLines() {
        const tableConfig = new TableConfig();
        tableConfig.pager.page = null;
        tableConfig.pager.pageSize = null;
        tableConfig.filters = [{field: 'isSPI', value: true}]
        this.isLoading = true;
        this.linesService.getAllLines(tableConfig).subscribe(
            (data: any) => {
                this.lines = data.items;
                this.isLoading = false;
            },
            (error: any) => {
                this._logger.error(error);
            }
        );
    }

    private isFormValid() {
        this.validationErrors = {};
        this.showValidations = true;
        let isValid = true;

        Object.keys(this.form.controls).forEach(key => {
            const control = this.form.controls[key];
            if (control.invalid) {
                isValid = false;
            }
        });

        return isValid;
    }

    private getFormValue() {
        return Object.assign({}, this.insertionCycle, this.form.getRawValue());
    }

}
